import { clearAuth, getAuth } from '@marvelapp/askhub-auth-ui';
import { fetchApi } from '@marvelapp/core';
import CONFIG from '../config';
const accessToken = getAuth(CONFIG);
export default function logout() {
    return fetchApi(`/api/logout/`, {
        method: 'GET',
        credentials: 'include',
        accessToken,
    }).finally(() => {
        clearAuth();
        if (window.Intercom) {
            window.Intercom('shutdown');
        }
    });
}
